import { TextBox } from '@apply/components';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface OtherDescriptionProps {
    readOnly?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const OtherDescription: React.FC<OtherDescriptionProps> = ({ readOnly = false, propertyGuid, isReview = false }) => {
    const [otherDescription, set_otherDescription] = useBudgetLandField<string>(
        propertyGuid,
        (b) => (b.values?.['Land Cost']?.['Other, Describe']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Land Cost': { ...b.values?.['Land Cost'], 'Other, Describe': [v, b.values?.['Land Cost']?.['Other, Describe']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Other - Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={otherDescription}
                />
            ) : (
                <TextBox
                    value={otherDescription}
                    onChange={(value) => set_otherDescription(value)}
                    label={label}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
